import React,{useState,useEffect} from "react";

export default function OpsPages({
    page, nav, isA, isDB, user, lang, T, C, fmt, today, todayStr,
  monthStart, monthEnd, fyStart, fyEnd, last7, last30, filterByDate,
  getFYList, gCalc, dlCSV, numToWords,
  canAccess, getPlanLimit, tenantPlan,
  companies, setCompanies, custs, setCusts, supps, setSupps,
  prods, setProds, orders, setOrders, pays, setPays,
  purs, setPurs, notes, setNotes, users, setUsers,
  beats, setBeats, expenses, setExpenses, cheques, setCheques,
  modal, setModal, form, setForm,
  payOid, setPayOid, nItems, setNItems,
  payAmt, setPayAmt, payMethod2, setPayMethod2,
  payingCust, setPayingCust, dbOtp, setDbOtp,
  dbOtpOrderId, setDbOtpOrderId,
  dateFrom, setDateFrom, dateTo, setDateTo,
  gTab, setGTab, selFY, setSelFY, cf, setCf, prev, setPrev,
  aiInsight, aiLoading, aiPurSug, setAiPurSug,
  myCompany, setMyCompany, editMyComp, setEditMyComp,
  fOrders, fPays, fPurs, lowS, tSales, tPaid, tDue, expiringBatches,
  loadData, showToast, handleOrder, handlePur, addPay, setSubPage, subPage,
  getAIInsights, getSmartPurchaseSuggestions,
  sendDailyReport, sendPaymentReminder, gc, API,
  accounts, setAccounts,
  srch, setSrch, oTab, setOTab, oPage, setOPage, payForm, setPayForm,
  pInv, pPur, pNote, pReceipt, waShare,
  Bdg, CB, Card, Sc, Row, Btn, Inp, Sel, Bar, Modal,
  AddProdToInvoice, InvModal, BankRecon, PhotoScanModal,
  NC, NI, SC, CC, editC, editComp, setEditComp,
  UnivFilter, CFbar
}){
  // ── Beat self-selection state — staff picks their own beat, instantly, no approval ──
  const [dispDate,setDispDate]=useState(todayStr());
  const [dispPicks,setDispPicks]=useState([]); // rows: {beat_id, staff_name, dispatch_date}
  const loadDispatch=async(dateStr)=>{
    try{ const d=await API.getBeatDispatch(dateStr); setDispPicks(Array.isArray(d)?d:[]); }catch(e){}
  };
  // On the Dispatch page, load whichever date is selected. Everywhere else (Dashboard,
  // Payments), always keep TODAY's picks loaded so beat-customer filtering stays correct.
  useEffect(()=>{
    if(page==="dispatch") loadDispatch(dispDate);
    else loadDispatch(todayStr());
  },[page,dispDate]);

  // Determines which beat(s) THIS staff/delivery user is on for a given date —
  // their own self-pick if they made one, otherwise falls back to the beat's default
  // day+staff assignment (so distributors who never touch this still work automatically).
  const getMyBeatsFor=(dateStr,dayName)=>{
    const myPick=dispPicks.find(p=>p.staff_name===user?.name && p.dispatch_date===dateStr);
    if(myPick){
      const b=beats.find(bt=>bt.id===myPick.beat_id);
      return b?[b]:[];
    }
    return beats.filter(b=>b.day===dayName && (b.staff||[]).includes(user?.name));
  };

  return(<>

          {page==="deliveries"&&isDB&&<div>
            <div style={{fontSize:17,fontWeight:800,marginBottom:4}}>🚚 My Deliveries</div>
            <div style={{fontSize:12,color:C.sub,marginBottom:12}}>Welcome {user?.name}! today's deliveries:</div>

            {/* Today Stats */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(100px,1fr))",gap:8,marginBottom:12}}>
              {(()=>{
                const todayOrders=orders.filter(o=>(o.date||"").slice(0,10)===todayStr());
                const pending=orders.filter(o=>o.status==="Dispatched");
                const delivered=orders.filter(o=>o.status==="Delivered"&&(o.date||"").slice(0,10)===todayStr());
                return<>
                  <Sc icon="📦" label="Pending" value={pending.length} color={C.warning}/>
                  <Sc icon="✅" label="Delivered Today" value={delivered.length} color={C.success}/>
                  <Sc icon="🛒" label="Today's Orders" value={todayOrders.length} color={C.primary}/>
                </>;
              })()}
            </div>

            {/* Pending Deliveries */}
            <div style={{fontSize:13,fontWeight:700,marginBottom:8,color:C.warning}}>⏳ Pending Deliveries</div>
            {orders.filter(o=>o.status==="Dispatched").length===0&&
              <Card style={{marginBottom:12}}><div style={{textAlign:"center",padding:16,color:C.sub,fontSize:12}}>✅ No pending deliveries!</div></Card>}
            {orders.filter(o=>o.status==="Dispatched").map(o=>{
              const co=gc(o.cid);
              return <Card key={o.id} style={{marginBottom:10,borderLeft:`4px solid ${C.warning}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                  <div style={{flex:1}}>
                    <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:3}}>
                      {co&&<CB co={co}/>}
                      <span style={{fontWeight:700,fontSize:14}}>{o.cust}</span>
                    </div>
                    <div style={{fontSize:11,color:C.sub}}>📋 {o.inv} • 📅 {(o.date||"").slice(0,10)}</div>
                    <div style={{fontSize:11,color:C.sub}}>📞 {o.phone||"—"}</div>
                    <div style={{fontSize:12,fontWeight:700,color:C.primary,marginTop:3}}>₹{fmt(o.total)}</div>
                    {o.status==="Dispatched"&&<div style={{fontSize:10,color:C.warning,fontWeight:700,marginTop:2}}>🚚 Dispatched — Confirm with OTP</div>}
                    {(()=>{
                      const custLoc=(custs.find(c=>c.name===o.cust)||{}).loc||"";
                      const mapsUrl=custLoc||`https://maps.google.com/?q=${encodeURIComponent((o.address||o.cust)+", India")}`;
                      return <div style={{display:"flex",gap:6,marginTop:7,flexWrap:"wrap"}}>
                        <button onClick={()=>window.open(mapsUrl,"_blank")} style={{display:"flex",alignItems:"center",gap:4,padding:"6px 12px",background:"#1A73E8",border:"none",color:"#fff",borderRadius:8,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>
                          📍 Navigate
                        </button>
                        {o.phone&&<button onClick={()=>window.open(`tel:${o.phone}`)} style={{display:"flex",alignItems:"center",gap:4,padding:"6px 12px",background:C.success,border:"none",color:"#fff",borderRadius:8,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>
                          📞 Call
                        </button>}
                        {!custLoc&&<span style={{fontSize:9,color:C.sub,alignSelf:"center"}}>⚠️ No pin — searching by address</span>}
                      </div>;
                    })()}
                  </div>
                  <div style={{fontSize:10,padding:"3px 8px",borderRadius:20,background:C.warning+"20",color:C.warning,fontWeight:700}}>{o.status}</div>
                </div>
                {/* OTP Confirm */}
                <div style={{background:"#FFF7ED",borderRadius:9,padding:10,border:`1px solid ${C.warning}40`}}>
                  <div style={{fontSize:11,fontWeight:600,color:C.warning,marginBottom:6}}>🔑 Enter OTP:</div>
                  <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                    <input
                      type="text"
                      placeholder="6 digit OTP..."
                      maxLength={6}
                      value={dbOtpOrderId===o.id?dbOtp:""}
                      onChange={e=>{setDbOtpOrderId(o.id);setDbOtp(e.target.value);}}
                      style={{flex:1,padding:"9px 12px",borderRadius:8,border:`1.5px solid ${C.warning}`,fontSize:14,fontWeight:700,textAlign:"center",outline:"none",letterSpacing:4,fontFamily:"inherit"}}
                    />
                    <button onClick={async()=>{
                      if(!dbOtp||dbOtp.length<6){showToast("Please enter the 6-digit OTP!","err");return;}
                      try{
                        await API.post(`/orders/${o.id}/verify-otp`,{otp:dbOtp});
                        setOrders(orders.map(x=>x.id===o.id?{...x,status:"Delivered"}:x));
                        setDbOtp("");setDbOtpOrderId(null);
                        showToast("✅ Delivery Confirmed!");
                        await loadData(true);
                      }catch(e){showToast("❌ Incorrect OTP!","err");}
                    }} style={{padding:"9px 16px",borderRadius:8,background:C.success,border:"none",color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>
                      ✅ Confirm
                    </button>
                  </div>
                </div>
              </Card>;
            })}

            {/* Today Delivered */}
            {orders.filter(o=>o.status==="Delivered"&&(o.date||"").slice(0,10)===todayStr()).length>0&&<>
              <div style={{fontSize:13,fontWeight:700,marginBottom:8,color:C.success}}>✅ Delivered Today ({orders.filter(o=>o.status==="Delivered"&&(o.date||"").slice(0,10)===todayStr()).length})</div>
              {orders.filter(o=>o.status==="Delivered"&&(o.date||"").slice(0,10)===todayStr()).map(o=>{
                const co=gc(o.cid);
                return <Card key={o.id} style={{marginBottom:8,borderLeft:`4px solid ${C.success}`,opacity:0.85}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div>
                      <div style={{display:"flex",alignItems:"center",gap:5}}>
                        {co&&<CB co={co}/>}
                        <span style={{fontWeight:600,fontSize:13}}>{o.cust}</span>
                      </div>
                      <div style={{fontSize:10,color:C.sub}}>{o.inv} • ₹{fmt(o.total)}</div>
                    </div>
                    <div style={{fontSize:10,padding:"2px 8px",borderRadius:20,background:C.success+"20",color:C.success,fontWeight:700}}>✅ Delivered</div>
                  </div>
                </Card>;
              })}
            </>}
          </div>}

          {page==="dash"&&<div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div style={{fontSize:17,fontWeight:800}}>📊 Dashboard</div>
              <button onClick={async()=>{showToast("🔄 Refreshing...");await loadData();}} style={{padding:"6px 12px",background:C.primary,border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"inherit"}}>🔄 Refresh</button>
            </div>

            {!isA&&(()=>{
              if(isDB){
                const pendingD=orders.filter(o=>o.status==="Dispatched"||o.status==="Processing");
                const deliveredToday=orders.filter(o=>o.status==="Delivered"&&(o.date||"").slice(0,10)===todayStr());
                const todayOrders=orders.filter(o=>(o.date||"").slice(0,10)===todayStr());
                return <>
                  <div style={{fontSize:13,color:C.sub,marginBottom:12}}>Welcome, {user?.name}! 👋</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9,marginBottom:9}}>
                    <Sc icon="📦" label="Pending Deliveries" value={pendingD.length} color={C.warning}/>
                    <Sc icon="✅" label="Delivered Today" value={deliveredToday.length} color={C.success}/>
                    <Sc icon="🛒" label="Today's Orders" value={todayOrders.length} color={C.primary}/>
                  </div>
                  <div style={{textAlign:"center",marginTop:6}}>
                    <Btn ch="🚚 Go to My Deliveries →" oc={()=>nav("deliveries")} color={C.primary} sm/>
                  </div>
                </>;
              }
              // Staff: My Collections + My Pending Dues
              const myPays=pays.filter(p=>(p.by||p.added_by)===user?.username);
              const collectedToday=myPays.filter(p=>(p.date||"").slice(0,10)===todayStr()).reduce((s,p)=>s+(+p.amt||0),0);
              const collectedTotal=myPays.reduce((s,p)=>s+(+p.amt||0),0);

              // My beats — beats where this staff is assigned TODAY (respects dispatch overrides)
              const myBeats=getMyBeatsFor(todayStr(),new Date().toLocaleDateString("en-US",{weekday:"long"}));
              const myBeatCustNames=myBeats.flatMap(b=>b.customers||[]);

              // My customers — added by me OR assigned in my beat
              const myCusts=custs.filter(c=>
                c.by===user?.username||
                c.added_by===user?.username||
                myBeatCustNames.includes(c.name)
              );
              const myPendingCusts=myCusts.filter(c=>(c.bal||0)>0);
              const myPending=myPendingCusts.reduce((s,c)=>s+(+c.bal||0),0);
              const myOrdersToday=orders.filter(o=>(o.by===user?.username||o.added_by===user?.username)&&(o.date||"").slice(0,10)===todayStr()).length;
              return <>
                <div style={{fontSize:13,color:C.sub,marginBottom:12}}>Welcome, {user?.name}! 👋</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9,marginBottom:9}}>
                  <Sc icon="💰" label="Collected Today" value={`₹${fmt(collectedToday)}`} color={C.success}/>
                  <Sc icon="📊" label="Total Collected" value={`₹${fmt(collectedTotal)}`} color={C.primary}/>
                  <Sc icon="⏳" label="Pending Collection" value={`₹${fmt(myPending)}`} color={C.danger}/>
                  <Sc icon="🛒" label="Today's Orders" value={myOrdersToday} color={C.info}/>
                </div>
                <div style={{fontSize:13,fontWeight:700,marginBottom:8,marginTop:4}}>⏳ Pending Collections</div>
                {myPendingCusts.length===0&&<Card><div style={{textAlign:"center",padding:16,color:C.sub,fontSize:12}}>✅ No pending dues to collect!</div></Card>}
                {myPendingCusts.slice(0,5).map(c=>
                  <Card key={c.id} style={{marginBottom:6,padding:"9px 12px"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{fontWeight:600,fontSize:12}}>{c.name}</span>
                      <span style={{fontWeight:700,color:C.danger}}>₹{fmt(c.bal)}</span>
                    </div>
                  </Card>
                )}
                {myPendingCusts.length>0&&<div style={{textAlign:"center",marginTop:6}}>
                  <Btn ch="💰 Go to Payment Collection →" oc={()=>nav("staff_pays")} color={C.primary} sm/>
                </div>}
              </>;
            })()}

            {isA&&<>
            {/* Date Filter Bar */}
            <Card style={{marginBottom:11,padding:"9px 11px",background:"#F8FAFC"}}>
              <div style={{display:"flex",gap:5,flexWrap:"wrap",marginBottom:7,alignItems:"center"}}>
                {[
                  {l:"All",f:"",t:""},
                  {l:"Today",f:todayStr(),t:todayStr()},
                  {l:"7 Days",f:last7(),t:todayStr()},
                  {l:"30 Days",f:last30(),t:todayStr()},
                  {l:"This Month",f:monthStart(),t:monthEnd()},
                  {l:"This FY",f:fyStart(),t:fyEnd()}
                ].map(p=>(
                  <button key={p.l} className="d2d-btn" onClick={()=>{setDateFrom(p.f);setDateTo(p.t);}} style={{padding:"5px 11px",borderRadius:20,border:`1.5px solid ${(dateFrom===p.f&&dateTo===p.t)?C.primary:C.border}`,background:(dateFrom===p.f&&dateTo===p.t)?C.primary:"#fff",color:(dateFrom===p.f&&dateTo===p.t)?"#fff":C.text,cursor:"pointer",fontSize:10,fontWeight:600,fontFamily:"inherit",boxShadow:(dateFrom===p.f&&dateTo===p.t)?"0 2px 6px "+C.primary+"40":"none"}}>{p.l}</button>
                ))}
                {/* FY Dropdown */}
                <select value={selFY} onChange={e=>{const y=+e.target.value;setSelFY(y);setDateFrom(`${y}-04-01`);setDateTo(`${y+1}-03-31`);}} style={{padding:"4px 8px",borderRadius:20,border:`1.5px solid ${C.primary}`,fontSize:10,fontWeight:700,color:C.primary,background:"#EFF6FF",cursor:"pointer",outline:"none"}}>
                  {getFYList().map(fy=><option key={fy.value} value={fy.value}>{fy.label}</option>)}
                </select>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                <div><div style={{fontSize:9,color:C.sub,marginBottom:2}}>From</div><input className="d2d-input" type="date" value={dateFrom} onChange={e=>setDateFrom(e.target.value)} style={{width:"100%",padding:"5px 8px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:11,boxSizing:"border-box"}}/></div>
                <div><div style={{fontSize:9,color:C.sub,marginBottom:2}}>To</div><input className="d2d-input" type="date" value={dateTo} onChange={e=>setDateTo(e.target.value)} style={{width:"100%",padding:"5px 8px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:11,boxSizing:"border-box"}}/></div>
              </div>
            </Card>

            {(()=>{
              const fOrders=filterByDate(orders,dateFrom,dateTo);
              const fPays=filterByDate(pays,dateFrom,dateTo);
              const fPurs=filterByDate(purs,dateFrom,dateTo);
              const dSales=fOrders.reduce((s,o)=>s+(+o.total||0),0);
              const dCollected=fPays.reduce((s,p)=>s+(+p.amt||0),0);
              const dPurCost=fPurs.reduce((s,p)=>s+(+p.total||0),0);
              // Due = Total customer balance (consistent with payments page)
              const dDue=tDue;
              const dProfit=dSales-dPurCost;
              return <>
                {/* HERO METRICS — Sales + Collected are what matters most at a glance, so they
                    get bigger, more prominent treatment instead of being visually equal to
                    every other number on the page. */}
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9,marginBottom:9}}>
                  <div style={{background:`linear-gradient(135deg,${C.success}15,${C.success}05)`,border:`1px solid ${C.success}25`,borderRadius:16,padding:"14px 15px"}}>
                    <div style={{fontSize:10,color:C.success,fontWeight:700,letterSpacing:0.3,marginBottom:3}}>💰 SALES</div>
                    <div style={{fontSize:21,fontWeight:800,color:C.text,letterSpacing:-0.3}}>₹{fmt(dSales)}</div>
                  </div>
                  <div style={{background:`linear-gradient(135deg,${C.primary}15,${C.primary}05)`,border:`1px solid ${C.primary}25`,borderRadius:16,padding:"14px 15px"}}>
                    <div style={{fontSize:10,color:C.primary,fontWeight:700,letterSpacing:0.3,marginBottom:3}}>💸 COLLECTED</div>
                    <div style={{fontSize:21,fontWeight:800,color:C.text,letterSpacing:-0.3}}>₹{fmt(dCollected)}</div>
                  </div>
                </div>
                {/* Secondary metrics — supporting numbers, smaller & grouped together */}
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9,marginBottom:11}}>
                  <Sc icon="⏳" label="Due" value={`₹${fmt(dDue)}`} color={C.danger}/>
                  <Sc icon="📦" label="Orders" value={fOrders.length} color={C.info}/>
                  <Sc icon="🛒" label="Purchase Cost" value={`₹${fmt(dPurCost)}`} color={C.warning}/>
                  <Sc icon={dProfit>=0?"📈":"📉"} label={dProfit>=0?"Profit":"Loss"} value={`₹${fmt(Math.abs(dProfit))}`} color={dProfit>=0?C.success:C.danger}/>
                </div>
                {lowS.length>0&&<Card style={{marginBottom:9,borderLeft:`3px solid ${C.danger}`,background:"#FEF2F2"}}><div style={{fontSize:12,fontWeight:700,color:C.danger,marginBottom:2}}>⚠️ Low Stock Alert</div><div style={{fontSize:10,color:C.sub}}>{lowS.length} products need restocking — {lowS.slice(0,3).map(p=>p.name).join(", ")}{lowS.length>3?"...":""}</div></Card>}
                {expiringBatches&&expiringBatches.length>0&&<Card style={{marginBottom:9,borderLeft:`3px solid ${C.warning}`,background:"#FFFBEB"}}><div style={{fontSize:12,fontWeight:700,color:C.warning,marginBottom:2}}>⏳ Expiry Alert</div><div style={{fontSize:10,color:C.sub}}>{expiringBatches.length} batch{expiringBatches.length>1?"es":""} expiring soon — {expiringBatches.slice(0,3).map(b=>b.product_name+" ("+(b.batch_no||"no batch#")+")").join(", ")}{expiringBatches.length>3?"...":""}</div></Card>}
                {companies.map(co=>{
                  const cOrd=fOrders.filter(o=>o.cid===co.id);
                  const cPays=fPays.filter(p=>p.cid===co.id);
                  const s=cOrd.reduce((x,o)=>x+(+o.total||0),0);
                  const p=cPays.reduce((x,pay)=>x+(+pay.amt||0),0);
                  const d=Math.max(0,s-p);
                  return <Card key={co.id} style={{marginBottom:9,borderLeft:`4px solid ${co.color}`,padding:"11px 13px"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
                      <div style={{display:"flex",alignItems:"center",gap:7}}><CB co={co}/><span style={{fontWeight:700,fontSize:12}}>{co.name}</span></div>
                      <div style={{fontSize:10,color:C.sub}}>Series: {co.prefix}-XXXX</div>
                    </div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:7}}>
                      <div style={{textAlign:"center",background:C.success+"10",borderRadius:7,padding:"7px"}}><div style={{fontSize:13,fontWeight:800,color:C.success}}>₹{fmt(s)}</div><div style={{fontSize:9,color:C.sub}}>Sales</div></div>
                      <div style={{textAlign:"center",background:C.danger+"10",borderRadius:7,padding:"7px"}}><div style={{fontSize:13,fontWeight:800,color:C.danger}}>₹{fmt(d)}</div><div style={{fontSize:9,color:C.sub}}>Due</div></div>
                    </div>
                  </Card>;
                })}
                <div style={{fontSize:12,fontWeight:700,marginBottom:7,marginTop:4}}>🕐 Recent Orders</div>
                {fOrders.slice(0,4).map(o=>{const co=gc(o.cid);return <Card key={o.id} onClick={()=>setPrev(o)} style={{marginBottom:6,padding:"9px 12px"}}><div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><div><div style={{display:"flex",alignItems:"center",gap:6}}><CB co={co}/><span style={{fontWeight:600,fontSize:12}}>{o.cust}</span></div><div style={{fontSize:9,color:C.sub}}>{o.inv} • {(o.date||"").slice(0,10)} • 👁️ tap for preview</div></div><div style={{textAlign:"right"}}><div style={{fontWeight:700,color:co?.color||C.primary}}>₹{fmt(o.total)}</div><Bdg l={o.status} c={SC[o.status]}/></div></div></Card>;})}

                {/* AI INSIGHTS */}
                {canAccess("ai")&&<Card style={{marginBottom:10,marginTop:8,border:`2px solid ${C.purple}30`,background:"linear-gradient(135deg,#F5F3FF,#EFF6FF)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <div style={{fontWeight:800,fontSize:13,color:C.purple}}>🤖 AI Business Insights</div>
                    <button onClick={getAIInsights} disabled={aiLoading} style={{background:C.purple,border:"none",color:"#fff",padding:"5px 12px",borderRadius:8,cursor:aiLoading?"not-allowed":"pointer",fontSize:11,fontWeight:700,fontFamily:"inherit"}}>
                      {aiLoading?"⏳ Analyzing...":"✨ Get Insights"}
                    </button>
                  </div>
                  {aiInsight?<div style={{fontSize:12,color:C.text,lineHeight:1.7,whiteSpace:"pre-wrap"}}>{aiInsight}</div>
                  :<div style={{fontSize:11,color:C.sub,textAlign:"center",padding:"12px 0"}}>
                    AI will analyze your business — sales trends, due alerts, stock warnings!
                  </div>}
                </Card>}

                {/* SMART PURCHASE SUGGESTION */}
                <Card style={{marginBottom:10,border:`2px solid ${C.warning}30`,background:"#FFFBEB"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <div style={{fontWeight:800,fontSize:13,color:C.warning}}>📦 Smart Purchase Order</div>
                    <button onClick={getSmartPurchaseSuggestions} style={{background:C.warning,border:"none",color:"#fff",padding:"5px 12px",borderRadius:8,cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"inherit"}}>
                      🔍 Check Stock
                    </button>
                  </div>
                  {aiPurSug?<>
                    <div style={{fontSize:12,color:C.text,lineHeight:1.7,whiteSpace:"pre-wrap",marginBottom:8}}>{typeof aiPurSug==="string"?aiPurSug:JSON.stringify(aiPurSug)}</div>
                    <button onClick={()=>setAiPurSug(null)} style={{marginTop:4,width:"100%",padding:"6px",background:"#fff",border:`1px solid ${C.border}`,borderRadius:7,cursor:"pointer",fontSize:11,fontFamily:"inherit"}}>✕ Clear</button>
                  </>:<div style={{fontSize:11,color:C.sub,textAlign:"center",padding:"12px 0"}}>Click "Check Stock" to get AI purchase recommendations for low-stock items!</div>}
                </Card>

                {/* DAILY REPORT */}
                <Card style={{marginBottom:10,border:`2px solid ${C.success}30`,background:"#F0FFF4"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div>
                      <div style={{fontWeight:800,fontSize:13,color:C.success}}>📊 Daily Report</div>
                      <div style={{fontSize:11,color:C.sub,marginTop:2}}>Send today's summary on WhatsApp</div>
                    </div>
                    <button onClick={sendDailyReport} style={{background:"#25D366",border:"none",color:"#fff",padding:"8px 14px",borderRadius:8,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>
                      📱 Send Report
                    </button>
                  </div>
                </Card>
              </>;
            })()}
            </>}
          </div>}

          {/* ORDERS */}
          {page==="beats"&&isA&&<div>
            <UnivFilter srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{fontSize:17,fontWeight:800}}>🗺️ Beat Management</div>
              <Btn ch="+ Add Beat" oc={()=>{setModal("beat");setForm({customers:[]});}}/>
            </div>

            {beats.length===0&&<Card style={{textAlign:"center",padding:30,color:C.sub}}>
              <div style={{fontSize:32,marginBottom:8}}>🗺️</div>
              <div style={{fontWeight:700,marginBottom:4}}>Koi beat nahi</div>
              <div style={{fontSize:12}}>Beat = Delivery route jaise Monday-Andheri, Tuesday-Bandra</div>
            </Card>}

            {beats.map(b=>{
              const beatCustomers=(b.customers||[]);
              const totalDue=beatCustomers.reduce((s,cn)=>{const c=custs.find(x=>x.name===cn);return s+(+c?.bal||0);},0);
              return<Card key={b.id} style={{marginBottom:10,borderLeft:`3px solid ${C.primary}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                  <div>
                    <div style={{fontWeight:800,fontSize:14}}>{b.name}</div>
                    <div style={{fontSize:11,color:C.sub,marginTop:2}}>
                      {b.day&&`📅 ${b.day}`}{(b.staff||[]).length>0&&` • 👤 ${(b.staff||[]).join(", ")}`}{b.areas&&` • 📍 ${b.areas}`}
                    </div>
                  </div>
                  <div style={{display:"flex",gap:6}}>
                    <Btn ch="✏️" oc={()=>{setModal("beat");setForm({...b,customers:b.customers||[]});}} color={C.info} sm out/>
                    <Btn ch="🗑️" oc={async()=>{
                      if(!window.confirm("Beat delete karna chahte ho?")) return;
                      setBeats(beats.filter(x=>x.id!==b.id));
                      try{await API.deleteBeat(b.id);}catch(e){}
                      showToast("Beat deleted!");
                    }} color={C.danger} sm out/>
                  </div>
                </div>

                {/* Customers */}
                {beatCustomers.length>0&&<div style={{marginBottom:8}}>
                  <div style={{fontSize:11,fontWeight:700,color:C.sub,marginBottom:5}}>👥 Customers ({beatCustomers.length}) • Total Due: <span style={{color:C.danger}}>₹{fmt(totalDue)}</span></div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
                    {beatCustomers.map(cn=>{
                      const c=custs.find(x=>x.name===cn);
                      return<span key={cn} style={{fontSize:10,padding:"3px 8px",borderRadius:10,background:(c?.bal||0)>0?"#FEF2F2":"#F0FDF4",color:(c?.bal||0)>0?C.danger:C.success,border:`1px solid ${(c?.bal||0)>0?"#FECACA":"#BBF7D0"}`}}>
                        {cn}{(c?.bal||0)>0?` ₹${fmt(c.bal)}`:""}
                      </span>;
                    })}
                  </div>
                </div>}

                {/* Collection Button */}
                {beatCustomers.length>0&&<Btn ch={`💰 Collect Payments (₹${fmt(totalDue)})`} oc={()=>{
                  setModal("beatCollect");setForm({beat:b});
                }} color={C.success} sm s={{width:"100%"}}/>}
              </Card>;
            })}

            {/* Beat Collection Modal */}
            {modal==="beatCollect"&&form.beat&&<Modal title={`💰 ${form.beat.name} Collection`} oc={()=>setModal(null)} w ch={<div>
              {(form.beat.customers||[]).map(cn=>{
                const c=custs.find(x=>x.name===cn);
                const due=+c?.bal||0;
                return<div key={cn} style={{marginBottom:10,padding:"10px 12px",borderRadius:10,border:`1.5px solid ${due>0?C.danger+"30":C.success+"30"}`,background:due>0?"#FFF5F5":"#F0FDF4"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div>
                      <div style={{fontWeight:700,fontSize:12}}>{cn}</div>
                      <div style={{fontSize:11,color:due>0?C.danger:C.success}}>{due>0?`Due: ₹${fmt(due)}`:"✅ Clear"}</div>
                    </div>
                    {due>0&&<Btn ch="💰 Collect" oc={()=>{
                      setModal("pay");setForm({cust:cn,amt:due,method:"Cash"});setPayOid("");
                    }} color={C.success} sm/>}
                  </div>
                </div>;
              })}
              <Btn ch="✅ Done" oc={()=>setModal(null)} color={C.success} s={{width:"100%",marginTop:8}}/>
            </div>}/>}
          </div>}

          {/* ── AAJ KA BEAT — simple self-select for staff, read-only overview for Admin ── */}
          {page==="dispatch"&&(()=>{
            const dispDayName=new Date(dispDate+"T00:00:00").toLocaleDateString("en-US",{weekday:"long"});

            if(isA){
              // ───── ADMIN: read-only overview — staff pick their own beat, nothing to manage here ─────
              return <div>
                <div style={{fontSize:17,fontWeight:800,marginBottom:4}}>🗺️ Aaj Ka Beat — Overview</div>
                <div style={{fontSize:12,color:C.sub,marginBottom:12}}>Staff apna beat khud select karte hain — yahan sirf dekh sakte ho aaj kaun kahan hai.</div>

                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14,background:"#F8FAFC",border:`1.5px solid ${C.border}`,borderRadius:9,padding:10}}>
                  <span style={{fontSize:12,fontWeight:600}}>📅 Date:</span>
                  <input type="date" value={dispDate} onChange={e=>setDispDate(e.target.value)} style={{padding:"5px 8px",borderRadius:6,border:`1.5px solid ${C.border}`,fontSize:12,fontFamily:"inherit"}}/>
                  <span style={{fontSize:11,color:C.sub}}>({dispDayName})</span>
                </div>

                {beats.length===0&&<Card style={{textAlign:"center",padding:30,color:C.sub}}>
                  <div style={{fontSize:32,marginBottom:8}}>🗺️</div>
                  <div style={{fontWeight:700}}>Pehle Beats banao</div>
                  <div style={{fontSize:12,marginTop:4}}>Beat Management page se area/route add karo</div>
                </Card>}

                {beats.map(b=>{
                  const picksHere=dispPicks.filter(p=>p.beat_id===b.id);
                  const isDefaultDay=b.day===dispDayName;
                  return <Card key={b.id} style={{marginBottom:10,borderLeft:`3px solid ${picksHere.length>0?C.success:(isDefaultDay?C.info:C.border)}`}}>
                    <div style={{fontWeight:800,fontSize:14}}>{b.name}</div>
                    <div style={{fontSize:10,color:C.sub,marginTop:2,marginBottom:8}}>
                      Default: {b.day} {(b.staff||[]).length>0?`• ${(b.staff||[]).join(", ")}`:"• koi staff nahi"}
                    </div>
                    <div style={{fontSize:11,fontWeight:600,color:C.sub,marginBottom:4}}>Aaj is beat pe kaun hai:</div>
                    {picksHere.length===0&&<div style={{fontSize:11,color:C.sub}}>
                      {isDefaultDay?`Koi ne self-select nahi kiya — default staff (${(b.staff||[]).join(", ")||"koi nahi"}) automatically apply hoga`:"Kisi ne aaj yeh beat select nahi ki"}
                    </div>}
                    {picksHere.length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                      {picksHere.map(p=>(
                        <span key={p.id} style={{padding:"4px 10px",borderRadius:20,background:"#F0FDF4",color:C.success,fontSize:11,fontWeight:700,border:"1px solid #BBF7D0"}}>✓ {p.staff_name}</span>
                      ))}
                    </div>}
                  </Card>;
                })}
              </div>;
            } else {
              // ───── STAFF/DELIVERY: simple self-select — pick a beat, instantly active ─────
              const myName=user?.name;
              const myPick=dispPicks.find(p=>p.staff_name===myName && p.dispatch_date===dispDate);
              const myBeatsToday=getMyBeatsFor(dispDate,dispDayName);

              const pickBeat=async(beatId)=>{
                try{
                  await API.setBeatDispatch({beat_id:beatId, dispatch_date:dispDate, staff_name:myName});
                  showToast("✅ Beat select ho gayi!");
                  await loadDispatch(dispDate);
                }catch(e){ showToast("❌ Failed: "+(e.message||"Server error"),"err"); }
              };

              return <div>
                <div style={{fontSize:17,fontWeight:800,marginBottom:4}}>🗺️ Mera Beat — Aaj</div>
                <div style={{fontSize:12,color:C.sub,marginBottom:14}}>{dispDayName}, {dispDate}</div>

                <Card style={{marginBottom:14,borderLeft:`3px solid ${C.info}`}}>
                  <div style={{fontSize:12,fontWeight:700,marginBottom:8}}>📍 Aaj Kaunsi Beat Karni Hai?</div>
                  <select value={myPick?.beat_id||""} onChange={e=>e.target.value&&pickBeat(e.target.value)} style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1.5px solid ${C.border}`,fontSize:13,fontFamily:"inherit",background:"#fff"}}>
                    <option value="">-- Beat chuno --</option>
                    {beats.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
                  </select>
                  {myPick&&<div style={{fontSize:11,color:C.success,marginTop:6,fontWeight:600}}>✓ Abhi select ki hui: {beats.find(b=>b.id===myPick.beat_id)?.name}</div>}
                </Card>

                {myBeatsToday.length===0&&<Card style={{textAlign:"center",padding:30,color:C.sub}}>
                  <div style={{fontSize:32,marginBottom:8}}>🏖️</div>
                  <div style={{fontWeight:700}}>Koi beat select nahi ki abhi</div>
                  <div style={{fontSize:12,marginTop:4}}>Upar se apni aaj ki beat chuno</div>
                </Card>}

                {myBeatsToday.map(b=>{
                  const beatCustomers=(b.customers||[]);
                  const totalDue=beatCustomers.reduce((s,cn)=>{const c=custs.find(x=>x.name===cn);return s+(+c?.bal||0);},0);
                  return <Card key={b.id} style={{marginBottom:10,borderLeft:`3px solid ${C.success}`}}>
                    <div style={{fontWeight:800,fontSize:15,marginBottom:2}}>{b.name}</div>
                    <div style={{fontSize:11,color:C.sub,marginBottom:8}}>{b.areas&&`📍 ${b.areas}`}</div>
                    {beatCustomers.length>0&&<>
                      <div style={{fontSize:11,fontWeight:700,color:C.sub,marginBottom:5}}>👥 {beatCustomers.length} Customers • Total Due: <span style={{color:C.danger}}>₹{fmt(totalDue)}</span></div>
                      <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
                        {beatCustomers.map(cn=>{
                          const c=custs.find(x=>x.name===cn);
                          return <span key={cn} style={{fontSize:10,padding:"3px 8px",borderRadius:10,background:(c?.bal||0)>0?"#FEF2F2":"#F0FDF4",color:(c?.bal||0)>0?C.danger:C.success,border:`1px solid ${(c?.bal||0)>0?"#FECACA":"#BBF7D0"}`}}>
                            {cn}{(c?.bal||0)>0?` ₹${fmt(c.bal)}`:""}
                          </span>;
                        })}
                      </div>
                    </>}
                    {beatCustomers.length===0&&<div style={{fontSize:11,color:C.sub}}>Is beat mein abhi koi customer add nahi hui</div>}
                  </Card>;
                })}
              </div>;
            }
          })()}

          {page==="cashbank"&&isA&&<div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{fontSize:17,fontWeight:800}}>💰 Cash & Bank</div>
              <Btn ch="+ Add Account" oc={()=>{setModal("addAccount");setForm({type:"cash",name:"",balance:0,note:""});}}/>
            </div>

            {/* Summary */}
            {(()=>{
              const cashAccs=(accounts||[]).filter(a=>a.type==="cash");
              const bankAccs=(accounts||[]).filter(a=>a.type==="bank");
              const totalCash=cashAccs.reduce((s,a)=>s+(+a.balance||0),0);
              const totalBank=bankAccs.reduce((s,a)=>s+(+a.balance||0),0);
              return<>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
                  <Card style={{background:"linear-gradient(135deg,#16A34A,#15803D)",borderRadius:12,padding:"14px 16px"}}>
                    <div style={{fontSize:11,color:"rgba(255,255,255,0.8)",marginBottom:4}}>💵 Cash in Hand</div>
                    <div style={{fontSize:22,fontWeight:900,color:"#fff"}}>₹{fmt(totalCash)}</div>
                    <div style={{fontSize:10,color:"rgba(255,255,255,0.6)",marginTop:3}}>{cashAccs.length} account{cashAccs.length!==1?"s":""}</div>
                  </Card>
                  <Card style={{background:"linear-gradient(135deg,#2563EB,#1D4ED8)",borderRadius:12,padding:"14px 16px"}}>
                    <div style={{fontSize:11,color:"rgba(255,255,255,0.8)",marginBottom:4}}>🏦 Bank Balance</div>
                    <div style={{fontSize:22,fontWeight:900,color:"#fff"}}>₹{fmt(totalBank)}</div>
                    <div style={{fontSize:10,color:"rgba(255,255,255,0.6)",marginTop:3}}>{bankAccs.length} account{bankAccs.length!==1?"s":""}</div>
                  </Card>
                </div>
                <Card style={{marginBottom:10,padding:"10px 14px",background:"#F8FAFC"}}>
                  <div style={{display:"flex",justifyContent:"space-between",fontWeight:700,fontSize:13}}>
                    <span>Total Balance</span>
                    <span style={{color:C.primary}}>₹{fmt(totalCash+totalBank)}</span>
                  </div>
                </Card>
              </>;
            })()}

            {/* Account Cards */}
            {(accounts||[]).length===0&&<Card style={{textAlign:"center",padding:30,color:C.sub}}>
              <div style={{fontSize:28,marginBottom:8}}>💰</div>
              <div style={{fontWeight:700,marginBottom:4}}>No accounts yet</div>
              <div style={{fontSize:12}}>Use + Add Account to add a Cash or Bank account</div>
            </Card>}

            {["cash","bank"].map(type=>{
              const accs=(accounts||[]).filter(a=>a.type===type);
              if(!accs.length) return null;
              return <div key={type} style={{marginBottom:14}}>
                <div style={{fontSize:12,fontWeight:700,color:C.sub,marginBottom:8}}>
                  {type==="cash"?"💵 Cash Accounts":"🏦 Bank Accounts"}
                </div>
                {accs.map(acc=><Card key={acc.id} style={{marginBottom:8,borderLeft:`3px solid ${type==="cash"?C.success:C.info}`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div>
                      <div style={{fontWeight:700,fontSize:13}}>{acc.name}</div>
                      {acc.note&&<div style={{fontSize:11,color:C.sub}}>{acc.note}</div>}
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <div style={{fontSize:18,fontWeight:900,color:type==="cash"?C.success:C.info}}>₹{fmt(acc.balance||0)}</div>
                      <Btn ch="📋" oc={async()=>{
                        setModal("acctLedger");setForm({acctId:acc.id,acctName:acc.name});
                        try{const r=await API.getAccountLedger(acc.id);setForm({acctId:acc.id,acctName:acc.name,ledger:r});}catch(e){showToast("❌ "+e.message,"err");}
                      }} color={C.primary} sm out/>
                      <Btn ch="✏️" oc={()=>{setModal("addAccount");setForm({...acc});}} color={C.info} sm out/>
                      <Btn ch="🗑️" oc={async()=>{
                        if(!window.confirm(`Delete ${acc.name}?`)) return;
                        try{await API.deleteAccount(acc.id);await loadData(true);showToast("Account deleted!");}catch(e){showToast("❌ "+e.message,"err");}
                      }} color={C.danger} sm out/>
                    </div>
                  </div>
                </Card>)}
              </div>;
            })}

            {/* Add/Edit Account Modal */}
            {modal==="addAccount"&&<Modal title={form.id?"✏️ Edit Account":"+ New Account"} oc={()=>{setModal(null);setForm({});}} ch={<div>
              <Sel l="Type" v={form.type||"cash"} oc={e=>setForm({...form,type:e.target.value})}
                ch={[<option key="cash" value="cash">💵 Cash Account</option>,<option key="bank" value="bank">🏦 Bank Account</option>]}/>
              <Inp l="Account Name *" v={form.name||""} oc={e=>setForm({...form,name:e.target.value})} p="e.g. Petty Cash, SBI Account"/>
              <Inp l="Opening Balance" v={form.balance||""} oc={e=>setForm({...form,balance:e.target.value})} t="number" p="0"/>
              {form.type==="bank"&&<Inp l="Bank / Note" v={form.note||""} oc={e=>setForm({...form,note:e.target.value})} p="e.g. SBI, HDFC Account No."/>}
              <div style={{display:"flex",gap:8,marginTop:8}}>
                <Btn ch="💾 Save" oc={async()=>{
                  if(!form.name){showToast("Account name is required!","err");return;}
                  try{
                    if(form.id){await API.updateAccount(form);}
                    else{await API.createAccount({...form,balance:+form.balance||0});}
                    await loadData(true);
                    setModal(null);setForm({});
                    showToast("✅ Account saved!");
                  }catch(e){showToast("❌ "+e.message,"err");}
                }} color={C.success} s={{flex:1}}/>
                <Btn ch="Cancel" oc={()=>{setModal(null);setForm({});}} color={C.sub} out s={{flex:1}}/>
              </div>
            </div>}/>}

            {/* Account Ledger Modal */}
            {modal==="acctLedger"&&<Modal title={`📋 Ledger — ${form.acctName||""}`} oc={()=>{setModal(null);setForm({});}} w ch={<div>
              {!form.ledger&&<div style={{textAlign:"center",padding:20,color:C.sub,fontSize:12}}>⏳ Loading...</div>}
              {form.ledger&&(()=>{
                const acct=form.ledger.account||{};
                const entries=form.ledger.entries||[];
                let running=+acct.opening_balance||0;
                const rows=entries.map(e=>{
                  running += (+e.cr||0)-(+e.dr||0);
                  return {...e, running};
                });
                return <>
                  <Card style={{marginBottom:10,padding:"9px 12px",background:"#F8FAFC"}}>
                    <div style={{display:"flex",justifyContent:"space-between",fontSize:12}}>
                      <span>Opening Balance</span><span style={{fontWeight:700}}>₹{fmt(acct.opening_balance||0)}</span>
                    </div>
                    <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginTop:4}}>
                      <span>Current Balance</span><span style={{fontWeight:700,color:C.primary}}>₹{fmt(acct.current_balance||0)}</span>
                    </div>
                  </Card>
                  {rows.length===0?
                    <div style={{textAlign:"center",padding:20,color:C.sub,fontSize:12}}>No transactions yet for this account.</div>
                  :<div style={{maxHeight:320,overflowY:"auto",border:`1px solid ${C.border}`,borderRadius:8}}>
                    <div style={{overflowX:"auto"}}><table style={{width:"100%",minWidth:480,borderCollapse:"collapse",fontSize:11}}>
                      <thead><tr style={{background:C.primary}}>
                        <th style={{padding:"5px 6px",color:"#fff",textAlign:"left"}}>Date</th>
                        <th style={{padding:"5px 6px",color:"#fff",textAlign:"left"}}>Type</th>
                        <th style={{padding:"5px 6px",color:"#fff",textAlign:"left"}}>Party</th>
                        <th style={{padding:"5px 6px",color:"#fff"}}>Dr</th>
                        <th style={{padding:"5px 6px",color:"#fff"}}>Cr</th>
                        <th style={{padding:"5px 6px",color:"#fff"}}>Balance</th>
                      </tr></thead>
                      <tbody>{rows.map((e,i)=><tr key={i} style={{background:i%2===0?"#F8FAFC":"#fff"}}>
                        <td style={{padding:"4px 6px"}}>{(e.date||"").slice(0,10)}</td>
                        <td style={{padding:"4px 6px"}}>{e.type}</td>
                        <td style={{padding:"4px 6px"}}>{e.party}{e.ref?` (${e.ref})`:""}</td>
                        <td style={{padding:"4px 6px",textAlign:"right",color:C.danger}}>{e.dr?`₹${fmt(e.dr)}`:"-"}</td>
                        <td style={{padding:"4px 6px",textAlign:"right",color:C.success}}>{e.cr?`₹${fmt(e.cr)}`:"-"}</td>
                        <td style={{padding:"4px 6px",textAlign:"right",fontWeight:700}}>₹{fmt(e.running)}</td>
                      </tr>)}</tbody>
                    </table></div>
                  </div>}
                  <Btn ch="Close" oc={()=>{setModal(null);setForm({});}} color={C.sub} out s={{width:"100%",marginTop:10}}/>
                </>;
              })()}
            </div>}/>}
          </div>}


          {/* ── EXPENSES ── */}
          {page==="expenses"&&isA&&<div>
            <UnivFilter srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{fontSize:17,fontWeight:800}}>💸 {T(lang,"expenses")}</div>
              <Btn ch="+ Add Expense" oc={()=>setModal("expense")}/>
            </div>
            {/* Summary */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
              {[
                {l:"This Month",v:expenses.filter(e=>e.date>=monthStart()&&e.date<=monthEnd()).reduce((s,e)=>s+(+e.amount||0),0),c:C.danger},
                {l:"This FY",v:expenses.filter(e=>e.date>=fyStart()&&e.date<=fyEnd()).reduce((s,e)=>s+(+e.amount||0),0),c:C.warning},
              ].map(s=>(
                <Card key={s.l} style={{textAlign:"center",borderLeft:`3px solid ${s.c}`}}>
                  <div style={{fontSize:11,color:C.sub}}>{s.l}</div>
                  <div style={{fontSize:20,fontWeight:800,color:s.c}}>₹{fmt(s.v)}</div>
                </Card>
              ))}
            </div>
            {/* Category wise */}
            {["Petrol/Travel","Staff Salary","Office Rent","Electricity","Marketing","Other"].map(cat=>{
              const catExp=expenses.filter(e=>e.category===cat);
              const catTotal=catExp.reduce((s,e)=>s+(+e.amount||0),0);
              if(!catTotal) return null;
              return <Card key={cat} style={{marginBottom:8,borderLeft:`3px solid ${C.info}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{fontWeight:700,fontSize:13}}>{cat}</div>
                  <div style={{fontWeight:800,color:C.danger}}>₹{fmt(catTotal)}</div>
                </div>
                <div style={{fontSize:11,color:C.sub,marginTop:2}}>{catExp.length} entries</div>
              </Card>;
            })}
            {expenses.length===0&&<div style={{textAlign:"center",padding:40,color:C.sub,background:"#fff",borderRadius:12}}>
              <div style={{fontSize:32,marginBottom:8}}>💸</div>
              <div style={{fontWeight:700}}>Koi expense nahi</div>
            </div>}
            {expenses.map(e=>(
              <Card key={e.id} style={{marginBottom:8,borderLeft:`3px solid ${C.danger}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:13}}>₹{fmt(e.amount)} — {e.category}</div>
                    <div style={{fontSize:11,color:C.sub}}>{(e.date||"").slice(0,10)} &nbsp;•&nbsp; {e.note||"—"}</div>
                    <div style={{fontSize:11,color:C.sub}}>By: {e.by}</div>
                  </div>
                  <button onClick={()=>setExpenses(expenses.filter(x=>x.id!==e.id))} style={{background:"transparent",border:`1px solid ${C.danger}`,color:C.danger,padding:"4px 8px",borderRadius:6,cursor:"pointer",fontSize:11}}>🗑️</button>
                </div>
              </Card>
            ))}
          </div>}

          {/* ── CHEQUES ── */}
          {page==="cheques"&&isA&&<div>
            <UnivFilter srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{fontSize:17,fontWeight:800}}>📝 {T(lang,"cheques")}</div>
              <Btn ch="+ Add Cheque" oc={()=>setModal("cheque")}/>
            </div>
            {/* Status tabs */}
            {["Pending","Deposited","Bounced","Cleared"].map(s=>{
              const cnt=cheques.filter(c=>c.status===s).length;
              if(!cnt) return null;
              return <div key={s} style={{display:"inline-block",marginRight:8,marginBottom:10,padding:"4px 12px",borderRadius:20,fontSize:11,fontWeight:700,background:s==="Pending"?C.warning+"20":s==="Deposited"?C.info+"20":s==="Bounced"?C.danger+"20":C.success+"20",color:s==="Pending"?C.warning:s==="Deposited"?C.info:s==="Bounced"?C.danger:C.success}}>
                {s}: {cnt}
              </div>;
            })}
            {cheques.length===0&&<div style={{textAlign:"center",padding:40,color:C.sub,background:"#fff",borderRadius:12}}>
              <div style={{fontSize:32,marginBottom:8}}>📝</div>
              <div style={{fontWeight:700}}>No cheques yet</div>
            </div>}
            {cheques.map(ch=>{
              const dueDate=new Date(ch.due_date);
              const today2=new Date();
              const daysLeft=Math.ceil((dueDate-today2)/(1000*60*60*24));
              const isOverdue=daysLeft<0&&ch.status==="Pending";
              return(
                <Card key={ch.id} style={{marginBottom:10,borderLeft:`3px solid ${ch.status==="Bounced"?C.danger:ch.status==="Cleared"?C.success:isOverdue?C.danger:C.warning}`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                    <div style={{flex:1}}>
                      <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                        <span style={{fontWeight:700,fontSize:14}}>₹{fmt(ch.amount)}</span>
                        <span style={{fontSize:10,padding:"2px 8px",borderRadius:20,background:ch.type==="issued"?C.warning+"20":C.info+"20",color:ch.type==="issued"?C.warning:C.info,fontWeight:700}}>{ch.type==="issued"?"📤 Issued":"📥 Received"}</span>
                        <span style={{fontSize:10,padding:"2px 8px",borderRadius:20,background:ch.status==="Bounced"?C.danger+"20":ch.status==="Cleared"?C.success+"20":C.warning+"20",color:ch.status==="Bounced"?C.danger:ch.status==="Cleared"?C.success:C.warning,fontWeight:700}}>{ch.status}</span>
                        {isOverdue&&<span style={{fontSize:10,color:C.danger,fontWeight:700}}>⚠️ OVERDUE!</span>}
                      </div>
                      <div style={{fontSize:12,color:C.sub,marginTop:3}}>👤 {ch.party} &nbsp;•&nbsp; 🏦 {ch.bank}</div>
                      <div style={{fontSize:11,color:C.sub}}>Cheque#: {ch.cheque_no} &nbsp;•&nbsp; Due: {(ch.due_date||"").slice(0,10)}</div>
                      {ch.status==="Pending"&&<div style={{fontSize:11,marginTop:3,color:daysLeft<3?C.danger:C.success,fontWeight:600}}>{daysLeft>0?`${daysLeft} days left`:"Due today!"}</div>}
                    </div>
                    <div style={{display:"flex",flexDirection:"column",gap:4}}>
                      {ch.status==="Pending"&&<>
                        <button onClick={async()=>{try{await API.updateCheque({...ch,status:"Deposited"});await loadData(true);}catch(e){showToast("❌ "+e.message,"err");}}} style={{background:C.info,border:"none",color:"#fff",padding:"4px 8px",borderRadius:6,cursor:"pointer",fontSize:10,fontWeight:700}}>Deposit</button>
                        <button onClick={async()=>{try{await API.updateCheque({...ch,status:"Bounced"});await loadData(true);}catch(e){showToast("❌ "+e.message,"err");}}} style={{background:C.danger,border:"none",color:"#fff",padding:"4px 8px",borderRadius:6,cursor:"pointer",fontSize:10,fontWeight:700}}>Bounce</button>
                      </>}
                      {ch.status==="Deposited"&&<button onClick={async()=>{try{await API.updateCheque({...ch,status:"Cleared"});await loadData(true);}catch(e){showToast("❌ "+e.message,"err");}}} style={{background:C.success,border:"none",color:"#fff",padding:"4px 8px",borderRadius:6,cursor:"pointer",fontSize:10,fontWeight:700}}>Cleared</button>}
                      <button onClick={async()=>{
                        if(!window.confirm(`Delete cheque #${ch.cheque_no}?`)) return;
                        try{await API.deleteCheque(ch.id);await loadData(true);showToast("Cheque deleted!");}catch(e){showToast("❌ "+e.message,"err");}
                      }} style={{background:"transparent",border:`1px solid ${C.danger}`,color:C.danger,padding:"4px 8px",borderRadius:6,cursor:"pointer",fontSize:10}}>🗑️</button>
                    </div>
                  </div>
                </Card>
              );
            })}
          </div>}

          {/* ── LOYALTY ── */}
          {page==="loyalty"&&isA&&<div>
            <div style={{fontSize:17,fontWeight:800,marginBottom:12}}>🏆 {T(lang,"loyalty")}</div>
            {/* Tiers */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:14}}>
              {[
                {l:"🥉 Silver",min:100000,max:500000,c:"#94A3B8",desc:"₹1L+ purchase"},
                {l:"🥇 Gold",min:500000,max:1000000,c:"#F59E0B",desc:"₹5L+ purchase"},
                {l:"💎 Platinum",min:1000000,max:Infinity,c:"#7C3AED",desc:"₹10L+ purchase"},
              ].map(tier=>{
                const cnt=custs.filter(c=>{const tot=orders.filter(o=>o.customer_name===c.name).reduce((s,o)=>s+(+o.total||0),0);return tot>=tier.min&&tot<tier.max;}).length;
                return <Card key={tier.l} style={{textAlign:"center",border:`2px solid ${tier.c}40`}}>
                  <div style={{fontSize:20}}>{tier.l.split(" ")[0]}</div>
                  <div style={{fontSize:18,fontWeight:800,color:tier.c}}>{cnt}</div>
                  <div style={{fontSize:10,color:C.sub}}>{tier.desc}</div>
                </Card>;
              })}
            </div>
            {/* Customer list with loyalty */}
            {custs.map(c=>{
              const custTotal=orders.filter(o=>o.customer_name===c.name).reduce((s,o)=>s+(+o.total||0),0);
              const tier=custTotal>=1000000?{l:"💎 Platinum",c:"#7C3AED",disc:10}:custTotal>=500000?{l:"🥇 Gold",c:"#F59E0B",disc:7}:custTotal>=100000?{l:"🥉 Silver",c:"#94A3B8",disc:5}:null;
              if(!tier) return null;
              return <Card key={c.id} style={{marginBottom:8,borderLeft:`3px solid ${tier.c}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <span style={{fontWeight:700,fontSize:14}}>{c.name}</span>
                      <span style={{fontSize:11,padding:"2px 8px",borderRadius:20,background:tier.c+"20",color:tier.c,fontWeight:700}}>{tier.l}</span>
                    </div>
                    <div style={{fontSize:11,color:C.sub,marginTop:3}}>Total Purchase: ₹{fmt(custTotal)}</div>
                    <div style={{fontSize:11,color:C.success,fontWeight:600,marginTop:2}}>🎁 Extra Discount: {tier.disc}%</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontSize:12,color:C.danger,fontWeight:700}}>Due: ₹{fmt(c.bal||0)}</div>
                    <div style={{fontSize:10,color:C.sub}}>{c.phone}</div>
                  </div>
                </div>
              </Card>;
            })}
            {custs.filter(c=>orders.filter(o=>o.customer_name===c.name).reduce((s,o)=>s+(+o.total||0),0)>=100000).length===0&&
              <div style={{textAlign:"center",padding:40,color:C.sub,background:"#fff",borderRadius:12}}>
                <div style={{fontSize:32,marginBottom:8}}>🏆</div>
                <div style={{fontWeight:700}}>No loyalty customers yet</div>
                <div style={{fontSize:12,marginTop:4}}>₹1L+ purchase karne wale customers yahan dikhenge</div>
              </div>
            }
          </div>}



  </>);
}
